import { LocationType } from '../Sidebar/LocationList';

// Map style and default location
export const MAPBOX_STYLE = 'mapbox://styles/mapbox/streets-v11';
export const MELBOURNE_COORDINATES = { lng: 144.9631, lat: -37.8136 };

// Marker color configuration
export const MARKER_COLORS = {
  [LocationType.NORMAL]: '#2196F3',   // Normal point - Blue
  [LocationType.START]: '#f39c12',    // Start point - Orange
  [LocationType.END]: '#8e44ad',      // End point - Purple
  [LocationType.WAYPOINT]: '#2ecc71'  // Waypoint - Green
};

// Layer ID constants
export const POINTS_SOURCE = 'points-source';
export const POINTS_CIRCLE_LAYER = 'points-circle-layer';
export const POINTS_SYMBOL_LAYER = 'points-symbol-layer';
export const AUTO_PATH_SOURCE = 'auto-path-source';
export const AUTO_PATH_LAYER = 'auto-path-layer';
export const CUSTOM_PATH_SOURCE = 'custom-path-source';
export const CUSTOM_PATH_LAYER = 'custom-path-layer';
export const DURATION_LABELS_SOURCE = 'duration-labels-source';
export const DURATION_LABELS_LAYER = 'duration-labels-layer';
export const CONNECTIONS_SOURCE = 'connections-source';
export const CONNECTIONS_LAYER = 'connections-layer';

// Path line styles
export const PATH_STYLES = {
  auto: {
    color: '#4285F4', // Bright Blue
    width: 5,         // Thicker
    opacity: 0.9
  },
  custom: {
    color: '#EA4335', // Bright Red
    width: 4,         // Slightly thinner
    opacity: 0.85,
    dasharray: [2, 2]  // Custom path uses dashed line
  },
}; 